import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'
import { Card } from 'components/Card'

export const ProductDetailCard = styled(Card, {
  padding: '$3',

  '@bp2': {
    padding: '$7 $10',
  },
})

export const StickyElement = styled('div', {
  position: 'fixed',
  bottom: '$3',
  left: 0,
  right: 0,
  zIndex: 100,
  display: 'flex',
  justifyContent: 'center',

  variants: {
    isHidden: {
      true: {
        display: 'none',
      },
    },
  },
})

export const ProductCTA = styled('div', {
  backgroundColor: '$accent-white',
  minHeight: '$13',
  border: '1px solid $secondary-600',
  borderRadius: '$4',
  boxShadow: '3px 5px 13px 0 $colors$tertiary-200',
  px: '$3',
  py: '$2',
  color: '$primary-800',
})

export const ProductDetailImage = styled('div', {
  display: 'flex',
  width: '100%',
  alignSelf: 'center',

  '@bp1': {
    maxWidth: '295px',
    maxHeight: '295px',
  },

  '@bp2': {
    maxWidth: 'unset',
    maxHeight: 'unset',
    alignSelf: 'flex-start',
    flex: 1,
  },
})

export const Information = styled(Stack, {
  flex: 1,
})
